module.exports = __webpack_public_path__ + "img/vlag-nl.4aafffb729a5b4f50b6cda3d694ee0c5.svg";